import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useSendFcmMutation } from '../../api/authApiSlice';
import { getToken, messaging, onMessage } from '../../auth/firebase';
import { vapidKey } from '../../utils/environment';

export default function FCMClient() {
    const [sendFcm] = useSendFcmMutation();
    const { enqueueSnackbar } = useSnackbar();

    onMessage(messaging, (payload) => {
        // eslint-disable-next-line no-console
        console.log('Message received. ', payload);
        enqueueSnackbar(
            `${payload.notification.title} . ${payload.notification.body}`,
            { variant: 'info' }
        );
    });

    useEffect(() => {
        getToken(messaging, { vapidKey })
            .then((fcm) => {
                fcm && sendFcm(fcm);
                !fcm &&
                    // eslint-disable-next-line no-console
                    console.log(
                        'No registration token available. Request permission to generate one.'
                    );
            })
            // eslint-disable-next-line no-console
            .catch((err) => console.log('cannot get fcm token: ', err));
    }, [sendFcm]);

    return <></>;
}
